import React from "react";

export default function LessonCard({ title, actions, children }) {
  return (
    <div className="flex-1 rounded-lg overflow-hidden bg-indigo-300 flex flex-col">
      {/* Header */}
      <div className="p-3 font-semibold flex items-center justify-between">
        <span>{title}</span>
        {actions && <div className="flex gap-2">{actions}</div>}
      </div>

      {/* Body */}
      <div className="flex-1 overflow-y-auto p-3 text-sm bg-white">
        {children}
      </div>
    </div>
  );
}
